import {
  SET_USERINFO,
  SET_USERROLEINFO,
  SET_TOKEN,
  SET_ROUTERS,
  SET_REPORT,
  SET_TABS,
  DEL_TABS,
  DEL_TABSARR,
  DEL_TABSOTHER,
  UPDATE_TABSOTHER,
  DEL_TABROUTER,
  SET_CURENTPAGE,
  SET_PAGECOUNT,
  SET_INFORMATIONMANAGERDATA,
  SET_CODE,
  SET_REFRESHTIME,
  SET_FILELIST,
  SET_ENTERFORM,
  SET_BASICINFOID,
  SET_BASICINFO,
  SET_END,
  SET_TRENDAREALIST,
  SET_SOURCEAREALIST,
  SET_ACCESSAREALIST,
  SET_TRENDCODE,
  SET_SOURCECODE,
  SET_ACCESSCODE,
  SET_TABS_ROUTER
} from './mutation-types.js';
import router from '@/router/router';
import { constantRouterMap } from '@/router/router';

export default {
  [SET_TABS_ROUTER](state, newTabsRouter) {
    state.tabsRouter = newTabsRouter;
  },
  // 设置用户信息
  [SET_USERINFO](state, userInfo) {
    state.userInfo = userInfo;
  },
  [SET_USERROLEINFO](state, userRoleInfo) {
    state.userRoleInfo = userRoleInfo;
  },
  [SET_TOKEN](state, token) {
    state.token = token;
  },
  [SET_REPORT](state, homeReportname) {
    state.homeReportname = homeReportname;
  },

  [SET_ROUTERS](state, routers) {
    state.addRouters = routers;
    state.routers = constantRouterMap.concat(routers);
  },
  [SET_TABS](state, router) {
    state.tabsRouter.push(router);
  },
  [DEL_TABS](state, idx) {
    state.tabsRouter.splice(idx, 1);
    },
  [DEL_TABROUTER](state, obj) {
    state.tabsRouter.splice(
      state.tabsRouter.findIndex((item) => {
        return item.path === obj.path;
      }),
      1
    );
    if (obj.to) {
      if (obj.query) {
        router.push({
          path: obj.to,
          query: obj.query,
        });
      } else {
        router.push(obj.to);
      }
    } else {
      router.push({
        path: state.tabsRouter[state.tabsRouter.length - 1].path,
        query: state.tabsRouter[state.tabsRouter.length - 1].query,
      });
    }
  },
  [DEL_TABSARR](state, obj) {
    state.tabsRouter.splice(obj.idx, obj.len);
  },
  [DEL_TABSOTHER](state, idx) {
    if (idx === 0) {
      state.tabsRouter = [state.tabsRouter[0]];
    } else {
      state.tabsRouter = [state.tabsRouter[0], state.tabsRouter[idx]];
    }
  },
  [UPDATE_TABSOTHER](state, obj) {
    // obj 参数为route和index
    state.tabsRouter[obj.index] = {
      path: obj.route.path,
      hash: obj.route.hash,
      name: obj.route.name,
      meta: obj.route.meta,
      params: obj.route.params,
      query: obj.route.query
    };
  },
  [SET_CURENTPAGE](state, val) {
    state.currentPage = val;
  },
  [SET_PAGECOUNT](state, val) {
    state.pageCount = val;
  },
  [SET_INFORMATIONMANAGERDATA](state, val) {
    state.InformationManagerData = val;
  },
  [SET_CODE](state, val) {
    state.code = val;
  },
  [SET_REFRESHTIME](state, val) {
    state.reFreshTime = val;
  },
  [SET_FILELIST](state, val) {
    state.fileList = val;
  },
  [SET_ENTERFORM](state, val) {
    state.enterForm = val;
  },
  [SET_BASICINFOID](state, val) {
    state.basicInfoId = val;
  },
  [SET_BASICINFO](state, val) {
    state.basicInfo = val;
  },
  [ SET_END](state, val) {
    state.end = val;
  },
  [SET_TRENDAREALIST](state, val) {
    state.trendAreaList = val;
  },
  [SET_SOURCEAREALIST](state, val) {
    state.sourceAreaList = val;
  },
  [SET_ACCESSAREALIST](state, val) {
    state.accessAreaList = val;
  },
  [SET_TRENDCODE](state, val) {
    state.trendCode = val;
  },
  [SET_SOURCECODE](state, val) {
    state.sourceCode = val;
  },
  [SET_ACCESSCODE](state, val) {
    state.accessCode = val;
  }
};
